import pages from '../namespaces/pages/zh-HK';
import components from '../namespaces/components/zh-HK';
import common from '../namespaces/common/zh-HK';
import errors from '../namespaces/errors/zh-HK';
import validation from '../namespaces/validation/zh-HK';
import gameDetail from '../namespaces/gameDetail/zh-HK';

export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
}; 